module.exports = __webpack_public_path__ + "img/P589205805.5a515c75.jpg";